var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('apexcharts',{ref:"chart",attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }